import { ApiResponse } from "@/models/http/ApiResponse";
import { HttpBaseService } from "./httpBase.service";
import { ProcessServiceDto } from "../dto/appointment/appointment.dto";
import { ProcesServiceDto } from "../dto/appointment/appointment.dto";
import { processManagerApiUrl } from "@/app.config";


export class ProcessService extends HttpBaseService {

    private static classInstance?: ProcessService;
    static apiBaseUrl = processManagerApiUrl;

    constructor(token: string) {
        super(token, ProcessService.apiBaseUrl);
    }

    public static getInstance(token: string): ProcessService {
        if (!this.classInstance) {
            this.classInstance = new ProcessService(token);
        }
        return this.classInstance;
    }

    public getBirthNumber(): Promise<ApiResponse<ProcessServiceDto>> {
        return this.instance.get('/birth/global-status')
            .then(response => {
                const apiResponse = new ApiResponse<ProcessServiceDto>();
                apiResponse.data = response.data;
                return apiResponse;
            })
            .catch(error => {
                return new ApiResponse<ProcessServiceDto>();
            });
    }

    public getDeathNumber(): Promise<ApiResponse<ProcessServiceDto>> {
        return this.instance.get('/death/global-status')
            .then(response => {
                const apiResponse = new ApiResponse<ProcessServiceDto>();
                apiResponse.data = response.data;
                return apiResponse;
            })
            .catch(error => {
                return new ApiResponse<ProcessServiceDto>();
            });
    }

    public getBirthList(requestPayload: any): Promise<ApiResponse<ProcesServiceDto>> {
        return this.instance.post('/birth/admin/search', requestPayload)
            .then(response => {
                const apiResponse = new ApiResponse<ProcesServiceDto>();
                apiResponse.data = response.data;
                return apiResponse;
            })
            .catch(error => {
                return new ApiResponse<ProcesServiceDto>();
            });
    }

    public getDeathList(requestPayload: any): Promise<ApiResponse<ProcesServiceDto>> {
        return this.instance.post('/death/admin/search', requestPayload)
            .then(response => {
                const apiResponse = new ApiResponse<ProcesServiceDto>();
                apiResponse.data = response.data;
                return apiResponse;
            })
            .catch(error => {
                return new ApiResponse<ProcesServiceDto>();
            });
    }
}
